import { htPdfDrawFullWidthBlockFrame, htPdfDrawFullWidthRowFrame } from './htPdfFullWidthFrame';
import {
  drawFullWidthRow,
  FONT_SM,
  joinLabelValue,
  PAD,
  rowHeightMm,
} from './htPdfRowDraw';
import { formatHtQuantityTreated, formatHtWeightKg } from './htDisplayFormat';

const SHIP_ROW_PT = {
  45: 11.5,
  46: 11.5,
  47: 11.5,
  52: 21.45,
  53: 12.45,
};

const TRANS_PAD_TOP = 1.6;
const TRANS_HEADER_LH = 2.9;
const H_TRANS_HEADER_BLOCK = TRANS_PAD_TOP + TRANS_HEADER_LH + 1.5;

function drawTransportSection(doc, S, xs, y) {
  const x0 = xs[0];
  const wFull = xs[5] - x0;
  const cx = x0 + wFull / 2;
  const maxW = wFull - PAD * 2;

  htPdfDrawFullWidthBlockFrame(doc, xs, y, H_TRANS_HEADER_BLOCK, 48, 49);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(FONT_SM);
  doc.text(S.HT_TRANSPORT_HEADER, cx, y + TRANS_PAD_TOP, {
    align: 'center',
    baseline: 'top',
    maxWidth: maxW,
  });
  doc.setFont('helvetica', 'normal');
  y += H_TRANS_HEADER_BLOCK;

  const h50 = rowHeightMm(50, { 50: 14.4 });
  htPdfDrawFullWidthRowFrame(doc, xs, y, h50, 50, []);
  doc.text(S.HT_TRANSPORT_OPTIONS_LINE, cx, y + h50 / 2, {
    align: 'center',
    baseline: 'middle',
    maxWidth: maxW,
  });
  y += h50;

  const h51 = rowHeightMm(51, { 51: 6 });
  htPdfDrawFullWidthRowFrame(doc, xs, y, h51, 51, []);
  y += h51;

  return y;
}

/** Filas 45–53: descripción de remessa (pesos, transporte, marcas). */
export function drawHtShippingBlockPdf(doc, params, xs, y) {
  const S = params.static;
  doc.setFont('helvetica', 'normal');

  y = drawFullWidthRow(
    doc,
    xs,
    y,
    45,
    joinLabelValue(S.HT_GROSS_LABEL, formatHtWeightKg(params.grossWeight)),
    SHIP_ROW_PT
  );
  y = drawFullWidthRow(
    doc,
    xs,
    y,
    46,
    joinLabelValue(S.HT_NET_LABEL, formatHtWeightKg(params.netWeight)),
    SHIP_ROW_PT
  );
  y = drawFullWidthRow(
    doc,
    xs,
    y,
    47,
    joinLabelValue(S.HT_VOLUME_LABEL, formatHtQuantityTreated(params.volumeDescription)),
    SHIP_ROW_PT
  );

  y = drawTransportSection(doc, S, xs, y);

  y = drawFullWidthRow(
    doc,
    xs,
    y,
    52,
    joinLabelValue(S.HT_MARKS_LABEL, params.distinctiveMark),
    SHIP_ROW_PT
  );
  y = drawFullWidthRow(doc, xs, y, 53, S.HT_MARKS_SUB, SHIP_ROW_PT, { italic: true });

  return y;
}
